// extracted by mini-css-extract-plugin
export var layoutContainer = "_bd-0";
export var layoutContainerNoRounding = "_bd-6";
export var layoutContainerOpen = "_bd-5";
export var layoutContainerResizing = "_bd-1";
export var mainContent = "_bd-2";
export var resizeDivider = "_bd-3";
export var slidePanel = "_bd-4";